import { render } from "./product-single.vue?vue&type=template&id=054f6a90&scoped=true&ts=true"
import script from "./product-single.vue?vue&type=script&lang=ts"
export * from "./product-single.vue?vue&type=script&lang=ts"

import "./styles/product-single.scss?vue&type=style&index=0&id=054f6a90&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054f6a90"]])

export default __exports__